import React from 'react'
import { Flex, Badge } from '@chakra-ui/react'

interface Props {
  tags: {
    text: string
    type: BadgeType
  }[]
}

export type BadgeType = 'tag' | 'level'

const badgeTypeBgMapping: Record<BadgeType, string> = {
  tag: '#EAEEF4',
  level: '#E6FAF6',
}

const ArticleTags = ({ tags }: Props) => {
  return (
    <Flex
      flexDirection="row"
      columnGap={'4px'}
      rowGap={'8px'}
      flexWrap={'wrap'}
    >
      {tags.map((item) => (
        <Badge
          key={item.text}
          h={'26px'}
          bg={badgeTypeBgMapping[item.type]}
          fontSize="16px"
          lineHeight="24px"
          fontWeight={400}
          p="2px 10px 0"
        >
          {item.text}
        </Badge>
      ))}
    </Flex>
  )
}

export default ArticleTags
